module.exports = __webpack_public_path__ + "img/6_155.6611df75.png";